import React from 'react';
import './styles.css';
import logo from '../../images/logo.png';
import { Link } from 'react-router-dom';
import LoginOrRegisterButtons from './LoginOrRegisterButtons';
import Intro from './Intro';

/**
 * Login view.
 *
 * Renders an IdentityProviderButton with method 'login' for each of the supported
 * identity providers.
 */
export default function Login() {
  const renderLogin = () => {
    return (
      <div className="login-wrapper flex flex-[35%_0_0] max-w-[550px] flex-col items-center justify-center p-10">
        <img src={logo} alt="Logo" className="logo w-[240px] mb-[130px]" />
        <LoginOrRegisterButtons method="login" />
        <div className="register-link-wrapper mt-[30px] text-grey2">
          No account yet?{' '}
          <Link to="/register" className="text-black no-underline">
            Register here
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div className="login-page flex min-h-screen">
      {renderLogin()}
      <Intro className="login-intro flex flex-1 flex-col items-center justify-center bg-[linear-gradient(135deg,#51adf6_0%,#2875ea_100%)] px-[100px] text-left text-[#f8fafb]" />
    </div>
  );
}
